import './style.css';

import React, { useState } from 'react';

import { AiFillSetting } from 'react-icons/ai';
import Form from 'react-bootstrap/Form';

import { lang } from '../../../utils/langs';
import ModalBtn from '../../molecules/modalButton/view';
import { setParametrizationBatch, getParametrization, getParametrizationTypes } from '../../../usecases/parametrization-usecase';
import { getPayMethods } from '../../../usecases/payments-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import SubaccountSearchDropdown from '../../molecules/SubaccountSearchDropdown/view';
import Tooltip from '@mui/material/Tooltip';
import { HelpCircle } from 'lucide-react';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';

function Parameterization({ profile }) {
    const [parametrization, SetParametrization] = useState([]);
    const [paramTypes, setParamTypes] = useState([]);
    const [paymethods, setPayMethods] = useState([]);
    const [draftChanges, setDraftChanges] = useState({});
    const [isSaving, setIsSaving] = useState(false);

    function aux_acc(key) {
        if (draftChanges[key] !== undefined) {
            return draftChanges[key];
        }
        const aux = parametrization.filter(aux_itm => (aux_itm.param_type && aux_itm.param_type.toLowerCase() === key.toLowerCase()));
        return aux[0];
    }

    function handleChange(account, param_type) {
        setDraftChanges(prev => ({
            ...prev,
            [param_type]: account ? { param_type, users_accounts_id: account.id, user_account: account } : null
        }));
    }

    function handleSaveAll() {
        const itemsToSave = Object.keys(draftChanges)
            .filter(key => draftChanges[key] !== null && draftChanges[key] !== undefined)
            .map(key => ({
                param_type: key,
                users_accounts_id: parseInt(draftChanges[key].users_accounts_id || draftChanges[key].id)
            }));

        if (itemsToSave.length === 0) return;

        setIsSaving(true);
        setParametrizationBatch(profile.uid, profile.cid, itemsToSave)
            .then(res => {
                dispatchCustomEvent("popup", { message: "✅ Parámetros guardados correctamente" });
                SetParametrization(prev => {
                    const next = [...prev];
                    res.forEach(updated => {
                        const index = next.findIndex(p => p.param_type === updated.param_type);
                        if (index !== -1) {
                            next[index] = updated;
                        } else {
                            next.push(updated);
                        }
                    });
                    return next;
                });
                setDraftChanges({});
            })

            .catch(err => {
                console.error("Error al guardar parámetros:", err);
                dispatchCustomEvent("popup", { message: "❌ Error al guardar parámetros" });
            })
            .finally(() => {
                setIsSaving(false);
            });
    }

    function funopen() {
        setDraftChanges({});
        getPayMethods(profile.uid, profile.cid).then(res => {
            setPayMethods(res);
        });

        // Siempre datos frescos — sin caché en getParametrization
        getParametrization(profile.uid, profile.cid).then(res => {

            SetParametrization(res);
        });

        getParametrizationTypes(profile.uid, profile.cid).then(res => {
            setParamTypes(res);
        });
    }

    const hasPendingChanges = Object.keys(draftChanges).length > 0;

    return (
        <div>
            <ModalBtn
                id="parametrization"
                className='btn-acc-rep-modal'
                icon={<AiFillSetting />}
                title="Parametros"
                onClick={funopen}
                style={{ width: '65vw', maxWidth: '95vw' }}
            >
                <div className="new-param-wrapper">
                    <div className="new-param-container">
                        {/* Columna Izquierda (30% - Sidebar) */}
                        <div className="new-param-sidebar">
                            <h5 className="new-param-section-title">Parámetros Contables</h5>
                            <p className="new-param-section-desc">
                                Configura las cuentas contables por defecto asociadas a los parámetros generales de tu negocio (ej. Caja general, cuentas de impuestos, etc.) y define las cuentas contables para cada forma de pago tanto en compras como en ventas.
                            </p>
                        </div>

                        {/* Columna Derecha (70% - Configuración) */}
                        <div className="new-param-form-right">
                            <Form action="javascript:void(0);" style={{ width: '100%', outline: 'none', display: 'block' }}>
                                
                                <h4 className="param-group-title">Parámetros Generales</h4>
                                <p className="param-group-desc">Define las cuentas base del sistema.</p>
                                
                                {paramTypes.map((type, index) => {
                                    const aux_accounts = aux_acc(type.value);
                                    return (
                                        <Form.Group key={index} className="mb-4">
                                        <div className="param-label-container">
                                            <label className="param-label">{lang("es", type.value)}</label>
                                            <Tooltip title={`Asocia la cuenta correspondiente para el parámetro: ${lang("es", type.value)}.`} arrow placement="top">
                                                <span className="param-help-icon">
                                                    <HelpCircle size={14} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                            <SubaccountSearchDropdown
                                                selected={aux_accounts}
                                                onSelected={(account) => handleChange(account, type.value)}
                                            />
                                        </Form.Group>
                                    );
                                })}

                                <hr className="new-param-separator" />

                                <h4 className="param-group-title">Formas de Pago - Ventas</h4>
                                <p className="param-group-desc">Define la cuenta contable donde se registrarán las ventas de cada método de pago.</p>
                                
                                {paymethods.map((item) => {
                                    const key = 'sell_' + item.method;
                                    const aux_accounts = aux_acc(key);
                                    return (
                                        <Form.Group key={key} className="mb-4">
                                        <div className="param-label-container">
                                            <label className="param-label">Ventas con {lang("es", item.method)}</label>
                                            <Tooltip title={`Cuenta para registrar las transacciones de ventas recibidas a través de ${lang("es", item.method)}.`} arrow placement="top">
                                                <span className="param-help-icon">
                                                    <HelpCircle size={14} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                            <SubaccountSearchDropdown
                                                selected={aux_accounts}
                                                onSelected={(account) => handleChange(account, key)}
                                            />
                                        </Form.Group>
                                    );
                                })}

                                <hr className="new-param-separator" />

                                <h4 className="param-group-title">Formas de Pago - Compras</h4>
                                <p className="param-group-desc">Define la cuenta contable donde se registrarán los egresos de cada método de pago.</p>
                                
                                {paymethods.map((item) => {
                                    const key = 'buy_' + item.method;
                                    const aux_accounts = aux_acc(key);
                                    return (
                                        <Form.Group key={key} className="mb-4">
                                        <div className="param-label-container">
                                            <label className="param-label">Compras con {lang("es", item.method)}</label>
                                            <Tooltip title={`Cuenta para registrar los egresos de compras realizadas a través de ${lang("es", item.method)}.`} arrow placement="top">
                                                <span className="param-help-icon">
                                                    <HelpCircle size={14} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                            <SubaccountSearchDropdown
                                                selected={aux_accounts}
                                                onSelected={(account) => handleChange(account, key)}
                                            />
                                        </Form.Group>
                                    );
                                })}

                            </Form>
                        </div>
                    </div>

                    {/* Footer de Acciones Globales */}
                    <div className="new-param-footer">
                        <ButtonPrimary
                            title={isSaving ? "Guardando..." : "Guardar Cambios"}
                            onClick={handleSaveAll}
                            disabled={!hasPendingChanges || isSaving}
                        />
                    </div>
                </div>
            </ModalBtn>
        </div>
    );
}

export default Parameterization;

